import apiClient from "./axios"

export const getAccountTransactions = async (params = {}) => {
  const response = await apiClient.get('/account-transactions', { params })
  return response.data
}

export const getAccountTransaction = async (id) => {
  const response = await apiClient.get(`/account-transactions/${id}`)
  return response.data
}

export const reverseAccountTransaction = async (id) => {
  const response = await apiClient.post(`/account-transactions/${id}/reverse`)
  return response.data
}
